import {createApp} from 'vue'
import App from './App.vue'
import router from "./router";
import {createPinia} from "pinia";
import PrimeVue from "primevue/config";
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';


import 'bootstrap/dist/css/bootstrap.css';
import './assets/main.css'
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import "primevue/resources/primevue.min.css";
import '/node_modules/primeflex/primeflex.css';
import dayjs from 'dayjs'

const app = createApp(App);
app.use(router);
app.use(createPinia());
app.provide('dayJS', dayjs)

app.use(PrimeVue, {ripple: true})
app.use(ToastService);
app.directive('ripple', Ripple);
app.mount('#app');

